import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { propArrayShape, propFunc } from '../../../../helpers/custom-prop-types';
import Hover from '../../../Ui/System/Hover';
import MySubscribeProfessionalUnitCard from './MySubscribeProfessionalUnitCard';
const MySubscribeProfessionalUnitsCardList = (props) => {
    const { list, onChange } = props;
    if (list.length === 0) {
        return (_jsx("div", Object.assign({ className: 'no-data-text' }, { children: "\u304A\u6C17\u306B\u5165\u308A\u306E\u30D5\u30A1\u30FC\u30E0\u306F\u307E\u3060\u3042\u308A\u307E\u305B\u3093" })));
    }
    return (_jsx("ul", Object.assign({ className: 'data_list_items' }, { children: list.map((item) => (_jsx(Hover, { children: _jsx("li", Object.assign({ className: 'item zoom_image_parent' }, { children: _jsx(MySubscribeProfessionalUnitCard, { item: item, onChange: onChange }) })) }, item.id))) })));
};
MySubscribeProfessionalUnitsCardList.propTypes = {
    list: propArrayShape().isRequired,
    onChange: propFunc().isRequired,
};
export default MySubscribeProfessionalUnitsCardList;
